import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "../../../Utils/FormInputs/TextField";
import { formatAmount } from "../../../Utils/formatNumbers";
import CustomDialog from "../../../Utils/Dialog/CustomDialog";
import { usePrint } from "../../../Utils/Template/usePrint";
import { PaymentVoucherReceipt } from "../../Report/PaymentVouchers";
import { Link } from "react-router-dom";

import axios from "axios";
import { CustomSelect } from "../../../Utils/FormInputs/SelectInput";
import Form from "react-bootstrap/Form";
import Label from "../../../Utils/FormInputs/Label";
import config from "../../../Helpers/config.json";
import { BackButton } from "../../../Utils/FormInputs/BackButton";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

const Alert = (props) => <MuiAlert elevation={6} variant="filled" {...props} />;

const useStyles = makeStyles((theme) => ({
    cleared: {
      color: "#28a745",
      fontWeight: 600,
      textTransform: "capitalize",
    },
    dueToday: {
      color: "#ff9800",
      fontWeight: 600,
      textTransform: "capitalize",
    },
    overdue: {
      color: "#f44336",
      fontWeight: 600,
      textTransform: "capitalize",
    },
    tableContainer: {
      overflowX: "auto",
      marginTop: theme.spacing(3),
      boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
      borderRadius: theme.spacing(1),
    },
    tableContainer: {
        overflowX: "auto",
        marginTop: theme.spacing(3),
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        borderRadius: theme.spacing(1),
        maxHeight: 500, // keeps table scrollable
      },
      
      table: {
        minWidth: 800,
        borderCollapse: "separate",
        borderSpacing: "0 6px",
        '& th': {
          backgroundColor: "#f8f9fa",
          fontWeight: 700,
          color: "#333",
          textAlign: "center",
          padding: theme.spacing(1.5),
          position: "sticky",
          top: 0,
          zIndex: 1,
        },
        '& td': {
          verticalAlign: "middle",
          textAlign: "center",
          padding: theme.spacing(1),
          background: "#fff",
          borderRadius: 4,
          boxShadow: "inset 0 -1px 0 rgba(0,0,0,0.05)",
        },
        '& tr:nth-of-type(odd) td': {
          backgroundColor: "#f9fafb",
        },
        '& tr:hover td': {
          backgroundColor: "#e3f2fd",
          transition: "0.2s",
        },
      },
      
    header: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      },
    },
    searchInput: {
      maxWidth: 350,
      width: "100%",
    },
    actionBtn: {
      margin: theme.spacing(0.5, 0.5, 0.5, 0),
      padding: theme.spacing(0.5, 1.5),
      fontSize: "0.9rem",
      borderRadius: 6,
      fontWeight: 500,
      transition: "all 0.3s ease",
      cursor: "pointer",
      border: "none",
      color: "#fff",
    },
    btnView: {
        backgroundColor: "#1976d2",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#115293",
        },
      },
    btnReceive: {
      backgroundColor: "#28a745",
      "&:hover": { backgroundColor: "#1e7e34" },
      "&:disabled": {
        backgroundColor: "#a5d6a7",
        cursor: "not-allowed",
      },
    },
    tooltip: {
      fontSize: "0.85rem",
    },
    noDataCell: {
      textAlign: "center",
      color: "#757575",
      fontStyle: "italic",
      padding: theme.spacing(2),
    },
    pagination: {
        marginTop: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
      },
      
      paginationControls: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        '& select': {
          padding: "6px 10px",
          borderRadius: 4,
          border: "1px solid #ccc",
          fontSize: "0.9rem",
        },
        '& button': {
          padding: "6px 12px",
          borderRadius: 4,
          border: "none",
          backgroundColor: "#1976d2",
          color: "#fff",
          fontWeight: 500,
          cursor: "pointer",
          transition: "0.2s",
          "&:hover": { backgroundColor: "#115293" },
          "&:disabled": { backgroundColor: "#a5d6a7", cursor: "not-allowed" },
        },
      },
      noDebtText: {
        color: "#757575",
        fontStyle: "italic",
        fontSize: "0.9rem",
        marginLeft: 4, // small spacing from button
        [theme.breakpoints.down("sm")]: {
          display: "block",
          marginLeft: 0,
          marginTop: theme.spacing(1),
        },
      },
      actionBtn: {
        margin: theme.spacing(0.5, 0.5, 0.5, 0),
        padding: theme.spacing(0.5, 1.2),
        fontSize: "0.85rem",
        borderRadius: "4px",
        fontWeight: 500,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.05)",
        },
      },
      btnReceive: {
        backgroundColor: "#28a745",
        color: "#fff",
        fontWeight: 600,
        fontSize: "0.95rem",
        padding: "8px 18px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
        transition: "all 0.3s ease",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        "&:hover": {
          backgroundColor: "#218838",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        },
        "&:disabled": {
          backgroundColor: "#a5d6a7",
          cursor: "not-allowed",
          boxShadow: "none",
        },
      },
      
    tabButton: {
      padding: theme.spacing(1, 3),
      border: "1px solid #ccc",
      borderRadius: 4,
      backgroundColor: "#fff",
      cursor: "pointer",
      fontWeight: 500,
      "&.active": {
        backgroundColor: "#1976d2",
        color: "#fff",
        borderColor: "#1976d2",
      },
    },
  }));
  
// === imports remain the same ===

const CustomerInvoices = ({ actions, match }) => {
    const classes = useStyles();
    const { customerId, customerName } = match.params;
  
    const [invoices, setInvoices] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [filterStatus, setFilterStatus] = useState("unpaid");
    const [perPage, setPerPage] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
  
    // Payment modal states
    const [modalOpen, setModalOpen] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [paymentDate, setPaymentDate] = useState(new Date().toISOString().slice(0, 10));
    const [notes, setNotes] = useState("");
    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
  
    const { handlePrint, fontSize, componentRef } = usePrint("");
    const [voucherDialogOpen, setVoucherDialogOpen] = useState(false);
    const [voucherData, setVoucherData] = useState(null);
  
    // Total balance
    const totalBalance = invoices.reduce((sum, inv) => sum + inv.balance, 0);
  

    const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState("");
const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error"

const [deposits, setDeposits] = useState([]);
const [loadingDeposits, setLoadingDeposits] = useState(false);

const [reverseDialogOpen, setReverseDialogOpen] = useState(false);
const [selectedPayment, setSelectedPayment] = useState(null);
const [reversing, setReversing] = useState(false);



// Active tab for invoices / total deposits
const [activeTab, setActiveTab] = useState("unpaid");



const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // useEffect(() => {
  //   if (activeTab === "totalDeposits") {
  //     fetchDeposits();
  //   }
  // }, [activeTab]);
  
  const fetchDeposits = async () => {
    setLoadingDeposits(true);
    try {
      const res = await axios.get(`${config.epharmUrl}/Cinvoice/customer/${customerId}/payment_summary`);
      setDeposits(res.data?.payment_summary || []);
    } catch (err) {
      console.error("Error fetching deposits:", err);
    } finally {
      setLoadingDeposits(false);
    }
  };
  
  const handleOpenReverse = (payment) => {
    setSelectedPayment(payment);
    setReverseDialogOpen(true);
  };
  
  const handleCloseReverse = () => {
    setSelectedPayment(null);
    setReverseDialogOpen(false);
  };

  
  const handleReversePayment = async (payment) => {
    if (!payment) return;
    try {
      setReversing(true);
  
      await axios.post(`${config.epharmUrl}/Cinvoice/reverse/invoice/payment`, {
        transaction_no: payment.transaction_no,
        payment_account_id: payment.paid_account?.account_id,
        reverse_amount: payment.total_paid,
        customer_id: customerId,
      });
  
      showSnackbar("Payment reversed successfully!", "success");
      fetchInvoices();
      fetchDeposits();
      handleCloseReverse(); // close the modal
    } catch (err) {
      console.error(err);
      showSnackbar("Failed to reverse payment. Try again.", "error");
    } finally {
      setReversing(false);
    }
  };
  
  
  
    // === fetch invoices ===
    const fetchInvoices = async () => {
      setLoading(true);
      try {
        const res = await axios.post(`${config.epharmUrl}/Cinvoice/invoices/list`, {
          customer_id: customerId,
          search,
          start_date: startDate || "",
          end_date: endDate || "",
          status_filter: filterStatus,
          per_page: perPage,
          page_number: pageNumber,
        });
        setInvoices(res.data?.data?.invoices || []);
        setTotalPages(res.data?.data?.total_pages || 1);
      } catch (err) {
        errorMessages(err, null, actions);
      } finally {
        setLoading(false);
      }
    };
  
    // === fetch accounts ===
    const fetchAccounts = async () => {
      try {
        const res = await axios.get(`${config.epharmUrl}/accounting/ledgers_under_category`);
        const options = res.data?.data?.map((item) => ({ value: item.id, label: item.head_name })) || [];
        setAccounts(options);
        // if (options.length) setSelectedAccount(options[0].value);
      } catch (err) {
        console.error("Error fetching accounts", err);
      }
    };
  
    useEffect(() => {
      if (customerId) {
        fetchInvoices();
        fetchAccounts();
        fetchDeposits();
      }
    }, [customerId]);
  
    useEffect(() => {
      fetchInvoices();
      fetchDeposits();
    }, [search, startDate, endDate, filterStatus, perPage, pageNumber]);
  
    // const handleOpenModal = () => {
    //   setPaymentAmount(0);
    //   setPaymentDate(new Date().toISOString().slice(0, 10));
    //   setNotes("");
    // //   setSelectedAccount(accounts.length ? accounts[0].value : null);
    //   setSubmitted(false);
    //   setModalOpen(true);
    // };
    const handleSubmitPayment = async (e) => {
        e.preventDefault();
        setSubmitted(true);
        if (!paymentAmount || !paymentDate || !selectedAccount) return;
      
        const data = {
          customer_id: customerId,
          paid_amount: paymentAmount,
          payment_date: paymentDate,
          payment_details: notes,
          debit_ledger: selectedAccount.value,
        };
      
        try {
          setSubmitting(true);
          const res = await axios.post(`${config.epharmUrl}/Cinvoice/handle/invoice/payments`, data);
          
          if (res.data?.data) {
            setVoucherData(res.data.data);
            setVoucherDialogOpen(true);
      
            // Show success message
            if (actions?.snackbarActions?.successSnackbar) {
              actions.snackbarActions.successSnackbar("Payment saved successfully!");
            }
              // Show snackbar
            showSnackbar("Payment saved successfully!", "success");
          }
      
          fetchInvoices();
          fetchDeposits();
          setModalOpen(false);
        } catch (err) {
          console.error(err);
          if (actions?.snackbarActions?.errorSnackbar) {
            actions.snackbarActions.errorSnackbar("Operation failed. Please try again.");
          }
        } finally {
          setSubmitting(false);
        }
      };
      
    // const handleSubmitPayment = async (e) => {
    //   e.preventDefault();
    //   setSubmitted(true);
    //   if (!paymentAmount || !paymentDate || !selectedAccount) return;
  
    //   const data = {
    //     customer_id: customerId,
    //     paid_amount: paymentAmount,
    //     payment_date: paymentDate,
    //     payment_details:notes,
    //     debit_ledger: selectedAccount.value,
    //   };
  
    //   try {
    //     setSubmitting(true);
    //     const res = await axios.post(`${config.epharmUrl}/Cinvoice/handle/invoice/payments`, data);
    //     if (res.data?.data) {
    //         // Show success message
    //         if (actions?.snackbarActions?.successSnackbar) {
    //             actions.snackbarActions.successSnackbar("Payment saved successfully!");
    //         }
    //       setVoucherData(res.data.data);
    //       setVoucherDialogOpen(true);
    //     }
    //     fetchInvoices();
    //     setModalOpen(false);
    //   } catch (err) {
    //     console.error(err);
    //     if (actions?.snackbarActions?.errorSnackbar) {
    //         actions.snackbarActions.errorSnackbar("Operation failed. Please try again.");
    //       }
    //   } finally {
    //     setSubmitting(false);
    //   }
    // };
    const handleOpenModal = () => {
        setPaymentAmount("");  // Clear default 0
        setPaymentDate(new Date().toISOString().slice(0, 10));
        setNotes("");
        setSelectedAccount(null);
        setSubmitted(false);
        setModalOpen(true);
    };
    const handleCloseModal = () => {
        setPaymentAmount("");
        setPaymentDate(new Date().toISOString().slice(0, 10));
        setNotes("");
        setSelectedAccount(null);
        setSubmitted(false);
        setModalOpen(false);
    };
    
    useEffect(() => {
      if (activeTab !== "totalDeposits") {
        setFilterStatus(activeTab);
        fetchDeposits();
        setPageNumber(1);
      }
    }, [activeTab]);
    
    const filteredInvoices = invoices.filter(inv => {
      if (activeTab === "unpaid") return inv.balance > 0;
      if (activeTab === "paid") return inv.balance === 0;
      return true;
    });
    
    return (
      <div className="customer-invoices">
        {/* Header */}
        <div className={classes.header}>
          <BackButton text="Back to Balance Summary" to="/accounting/debtors/customer" />
          <h3>Invoices for {customerName}</h3>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <TextField type="text" placeholder="Search invoice" value={search} onChange={(e) => setSearch(e.target.value)} className={classes.searchInput} />
            <TextField type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            <TextField type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <button
                className={classes.btnReceive}
                onClick={handleOpenModal}
                disabled={activeTab === "paid"   || totalBalance <= 0}
            >
                Receive Payment
            </button>
            {totalBalance <= 0 && (
                <span className={classes.noDebtText}>No debt to receive payment</span>
            )}
            </div>

          </div>
        </div>
  
        {/* Tabs */}
        {/* <div className={classes.tabsContainer}>
          {["unpaid", "paid"].map(status => (
            <button key={status} className={`${classes.tabButton} ${filterStatus === status ? "active" : ""}`} onClick={() => { setFilterStatus(status); setPageNumber(1); }}>
              {status === "paid" ? "Paid" : "Unpaid"}
            </button>
          ))}
        </div> */}
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
  {["unpaid", "paid", "totalDeposits"].map(tab => (
    <button
      key={tab}
      className={`${classes.tabButton} ${activeTab === tab ? "active" : ""}`}
      onClick={() => { setActiveTab(tab); setPageNumber(1); }}
    >
      {tab === "unpaid" ? "Unpaid Invoices" : tab === "paid" ? "Paid Invoices" : "Total Deposits"}
    </button>
  ))}
</div>

  
        {/* Total Balance */}
        <div style={{ marginBottom: 16 }}>
          <strong>Total Balance: {formatAmount(totalBalance)}</strong>
        </div>
  
        {/* Payment Modal */}
        <CustomDialog
            open={modalOpen}
            handleClose={handleCloseModal}
            title="Receive Payment"
            maxWidth="sm"
            >
  <form
    onSubmit={handleSubmitPayment}
    style={{ display: "flex", flexDirection: "column", gap: 16 }}
  >
    <div>
      <strong>Total Balance: {formatAmount(totalBalance)}</strong>
    </div>
    <Label name="Payment Amount " type/>
    <TextField
  label="Payment Amount"
  type="number"
  value={paymentAmount}
  onFocus={() => paymentAmount === "" && setPaymentAmount("")} // optional, focus clears
  onChange={(e) => {
    const value = e.target.value === "" ? "" : Number(e.target.value);
    setPaymentAmount(value > totalBalance ? totalBalance : value);
  }}
  placeholder="Enter amount"
/>
{submitted && paymentAmount > totalBalance && (
  <div className="help-block">
    Payment cannot exceed total balance ({formatAmount(totalBalance)})
  </div>
)}



    <Label name="Payment Date " type/>
    <TextField
      label="Payment Date"
      type="date"
      value={paymentDate}
      onChange={(e) => setPaymentDate(e.target.value)}
    />
    <Label name="Payment Details" />
    <TextField
      label="Notes / Details"
      type="text"
      value={notes}
      onChange={(e) => setNotes(e.target.value)}
    />

    {/* === Combo Box for Payment Account === */}
    <Form.Group>
      <Label name="Payment Account" type />
      <CustomSelect
        value={selectedAccount}
        submitted={submitted}
        onChange={setSelectedAccount}
        options={accounts} // should be [{ value, label }]
        placeholder="Select payment account"
      />
      {submitted && !selectedAccount && (
        <div className="help-block">Payment account is required</div>
      )}
    </Form.Group>

    <div style={{ display: "flex", gap: 8 }}>
      <button
        type="submit"
        disabled={submitting || !paymentAmount || !selectedAccount}
        style={{
          padding: "10px 20px",
          borderRadius: 6,
          border: "none",
          backgroundColor: "#28a745",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        {submitting ? "Submitting..." : "Submit Payment"}
      </button>
      <button
        type="button"
        style={{
          padding: "10px 20px",
          borderRadius: 6,
          border: "1px solid #ccc",
          backgroundColor: "#f5f5f5",
          cursor: "pointer",
        }}
        onClick={() => setModalOpen(false)}
      >
        Cancel
      </button>
    </div>
  </form>
</CustomDialog>

        {/* Voucher Dialog
        <CustomDialog open={voucherDialogOpen} handleClose={() => setVoucherDialogOpen(false)} title="Payment Voucher" maxWidth="lg" handlePrint={handlePrint}>
          <div ref={componentRef} style={{ padding: "16px 30px" }}>
            <style>{fontSize()}</style>
            {voucherData && <PaymentVoucherReceipt voucher_no={voucherData.voucher_id} />}
          </div>
        </CustomDialog> */}
  
        {/* Table */}
        {activeTab === "totalDeposits" ? (
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table stickyHeader className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Payment Date</TableCell>
                  <TableCell>Transaction No</TableCell>
                  <TableCell>Invoice No</TableCell>
                  <TableCell>Total Deposits</TableCell>
                  <TableCell>Payment Account</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loadingDeposits ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">Loading...</TableCell>
                  </TableRow>
                ) : deposits.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">No deposits found</TableCell>
                  </TableRow>
                ) : deposits.map((dep, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{new Date(dep.first_payment_date).toLocaleDateString()}</TableCell>
                    <TableCell>{dep.transaction_no || " "}</TableCell>

                    <TableCell>{dep.invoice_ids.join(", ")}</TableCell>
                    <TableCell>{formatAmount(dep.total_paid)}</TableCell>
                    <TableCell>{dep.paid_account?.account_name || "-"}</TableCell>
                    <TableCell>
                    <button
                      onClick={() => handleOpenReverse(dep)}
                      style={{
                        padding: "4px 8px",
                        borderRadius: 4,
                        backgroundColor: "#dc3545",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer"
                      }}
                    >
                      Reverse
                    </button>
                  </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

) : (
  /* existing invoice table code for unpaid/paid */

        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table stickyHeader className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Invoice No</TableCell>
                <TableCell>Total Bill</TableCell>
                <TableCell>Total Paid</TableCell>
                <TableCell>Balance</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={6} align="center">Loading...</TableCell></TableRow>
              ) : filteredInvoices.length === 0 ? (
                <TableRow><TableCell colSpan={6} align="center">No invoices found</TableCell></TableRow>
              ) : (
                filteredInvoices.map((inv, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{inv.invoice_date}</TableCell>
                    <TableCell>{inv.invoice_number}</TableCell>
                    <TableCell>{formatAmount(inv.total_bill)}</TableCell>
                    <TableCell>{formatAmount(inv.total_paid)}</TableCell>
                    <TableCell>{formatAmount(inv.balance)}</TableCell>
                    <TableCell>{inv.status} </TableCell>
                    <TableCell>
                        <Link
                        to={`/customer_invoice_details/${customerId}/${customerName}/${inv.invoice_id}`}
                        className={`${classes.actionBtn} ${classes.btnView}`}
                        >
                        View
                        </Link></TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        )}

        <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
            <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
                {snackbarMessage}
            </Alert>
            </Snackbar>
            <CustomDialog open={reverseDialogOpen} handleClose={handleCloseReverse} title="Confirm Reversal">
              <div style={{ padding: "16px" }}>
                Are you sure you want to reverse payment for transaction {selectedPayment?.transaction_no}?
                <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
                <button
                  onClick={() => handleReversePayment(selectedPayment)}
                  disabled={reversing}
                  style={{ padding: "8px 16px", backgroundColor: "#dc3545", color: "#fff", border: "none", borderRadius: 4 }}
                >
                  {reversing ? "Reversing..." : "Yes, Reverse"}
                </button>

                  <button
                    onClick={handleCloseReverse}
                    style={{ padding: "8px 16px", borderRadius: 4, border: "1px solid #ccc" }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </CustomDialog>


        {/* Pagination */}
        <div className={classes.pagination}>
          <div>Page {pageNumber} of {totalPages}</div>
          <div className={classes.paginationControls}>
            <label>Per Page:</label>
            <select value={perPage} onChange={(e) => setPerPage(Number(e.target.value))}>
              {[20, 50, 100].map(num => <option key={num} value={num}>{num}</option>)}
            </select>
            <button onClick={() => setPageNumber(Math.max(pageNumber - 1, 1))} disabled={pageNumber === 1}>Prev</button>
            <button onClick={() => setPageNumber(Math.min(pageNumber + 1, totalPages))} disabled={pageNumber === totalPages}>Next</button>
          </div>
        </div>
      </div>

      
    );
  };
  
  export default CustomerInvoices;
  